import type { ReactNode } from "react";

import { createContext } from "react";

export interface ProjectDetailsContextType {
  isDesignerPrefsReadOnly: boolean;
  isReadOnly: boolean;
  projectId: number;
}

export const ProjectDetailsContext = createContext<
  ProjectDetailsContextType | undefined
>(undefined);

export function ProjectDetailsProvider({
  children,
  isDesignerPrefsReadOnly,
  isReadOnly,
  projectId,
}: { children: ReactNode } & ProjectDetailsContextType) {
  return (
    <ProjectDetailsContext.Provider
      value={{ isDesignerPrefsReadOnly, isReadOnly, projectId }}
    >
      {children}
    </ProjectDetailsContext.Provider>
  );
}
